<script setup lang="ts">
import { useFetchGeneral } from '~/api/service/general/index.service'
import HomeCardTitle from '~/components/@pages/home/HomeCardTitle.vue'
import HomeChartTitle from '~/components/@pages/home/HomeChartTitle.vue'
import CustomSuspense from '~/components/suspense/CustomSuspense.vue'
import IconTooltip from '~/components/tooltip/IconTooltip.vue'
import { HOME_CHART_TOOLTIP, HOME_REFETCH_PARAMS } from '~/constants/general.const'
import { IMAGE_BASE_URL } from '~/constants/image.constant'
import { generalParamType } from '~/types/general.type'

const { data, isLoading } = useFetchGeneral(HOME_REFETCH_PARAMS)
const { data: countData, isLoading: countLoading } = useFetchGeneral([ generalParamType.DAILY_ACCOUNT ])

const totalCount = computed(() => {
  if (!countData.value) {
    return
  }
  return setComma(countData.value.FDACI.OBJ.DACNT)
})
</script>

<template>
  <div>
    <CustomSuspense :is-loading="isLoading || countLoading">
      <template #loading>
        <img
          :src="`${IMAGE_BASE_URL}/skeleton/home/progress-bar.png`"
          alt="line chart skeleton"
        >
      </template>
      <template #default>
        <Card class="flex h-full flex-col justify-start gap-y-8 p-5">
          <HomeCardTitle>
            <div class="flex items-center gap-x-1">
              <span>Daily Account Created(Avg)</span>
              <IconTooltip :tooltip="HOME_CHART_TOOLTIP[generalParamType.DAILY_ACCOUNT]" />
              :
              <strong class="font-normal text-primary">{{ totalCount }}</strong><span> addresses</span>
            </div>
          </HomeCardTitle>
          <div class="flex flex-col gap-y-2">
            <HomeChartTitle
              title="Total Accounts"
              :tooltip="HOME_CHART_TOOLTIP[generalParamType.ACCOUNT]"
            />
            <strong class="text-3xl text-primary">{{ setComma(data.FAI.OBJ.TACNT) }}</strong>
          </div>
          <div class="mt-auto flex flex-col gap-y-4 text-xl">
            <div>
              <div
                class="percentage eoa"
                v-tooltip="`${data.FAI.OBJ.TEOAPR}%`"
                :style="{width: `${data.FAI.OBJ.TEOAPR}%`}"
              />
              <span class="type">EOA<strong class="count">{{ setComma(data.FAI.OBJ.TEOACNT) }}</strong></span>
            </div>
            <div>
              <div
                class="percentage ca"
                v-tooltip="`${data.FAI.OBJ.TCAPR}%`"
                :style="{width: `${data.FAI.OBJ.TCAPR}%`, minWidth: '2px'}"
              />
              <span class="type">CA<strong class="count">{{ setComma(data.FAI.OBJ.TCACNT) }}</strong></span>
            </div>
          </div>
        </Card>
      </template>
    </CustomSuspense>
  </div>
</template>

<style scoped lang="scss">
.percentage {
  @apply min-w-[4px] h-4 rounded-2xl mb-2 cursor-pointer relative overflow-hidden;

  &.eoa {
    @apply bg-explorer-purple;
  }

  &.ca {
    @apply bg-explorer-green;
  }

  //&:after {
  //  content: ' ';
  //  @apply bg-point-color absolute w-full h-full transition duration-100 ease-in-out;
  //
  //  &:hover {
  //    @apply opacity-0;
  //  }
  //}
}

.type {
  @apply flex items-center font-bold text-primary/40 gap-x-2;
}

.count {
  @apply text-primary font-normal;
}
</style>